/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryStockDto as DigiworkMaitreDPosDtoInventoryInventoryStockDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-stock-dto';
import { RestockInventoryItemDto as DigiworkMaitreDPosDtoPurchesOrdersRestockInventoryItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/restock-inventory-item-dto';

export interface RestockInventoryItem$Params {
  inventoryId: string;
  stockItemId: string;
      body?: DigiworkMaitreDPosDtoPurchesOrdersRestockInventoryItemDto
}

export function restockInventoryItem(http: HttpClient, rootUrl: string, params: RestockInventoryItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryStockDto>> {
  const rb = new RequestBuilder(rootUrl, restockInventoryItem.PATH, 'post');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.path('stockItemId', params.stockItemId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryStockDto>;
    })
  );
}

restockInventoryItem.PATH = '/api/inventories/{inventoryId}/stock/{stockItemId}';
